// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#0e8fa7","white":"#fff","faviconCode":"\"/assets/img/lausitz/favicon.svg\""};